import axios from 'axios';

const loadTypeExpenses = (options, obj) => {
  if (options.state.type_expenses.length > 0) {
    return;
  }

  axios.get('/financial/financial/type_expenses/', {
    params: obj,
  }).then(response => {
    options.commit('SET_TYPE_EXPENSES', response.data.data);
  }).catch(() => {
    options.commit('SET_ERROR_MESSAGE', { title: 'Houve um erro', message: 'Tente novamente' }, { root: true });
  });
};

const loadCostCenters = (options, obj) => {
  if (options.state.cost_centers.length > 0) {
    return;
  }
  axios.get('/financial/financial/cost_centers/', {
    params: obj,
  }).then(response => {
    options.commit('SET_COST_CENTERS', response.data.data);
  });
};

const loadCostCentersEmployees = (options, obj) => {
  if (options.state.cost_centers_employees.length > 0) {
    return;
  }
  axios.get('/financial/financial/cost_centers_employees/', {
    params: obj,
  }).then(response => {
    options.commit('SET_COST_CENTERS_EMPLOYEES', response.data.data);
  });
};

const loadPayingSources = (options, obj) => {
  if (options.state.paying_sources.length > 0) {
    return;
  }
  axios.get('/financial/financial/paying_sources/', {
    params: obj,
  }).then(response => {
    options.commit('SET_PAYING_SOURCES', response.data.data);
  });
};

const loadProviders = (options, obj) => {
  if (options.state.providers.length > 0) {
    return;
  }
  axios.get('/financial/financial/providers/', {
    params: obj,
  }).then(response => {
    options.commit('SET_PROVIDERS', response.data.data);
  });
};

export default {
  loadTypeExpenses,
  loadCostCenters,
  loadCostCentersEmployees,
  loadPayingSources,
  loadProviders,
};
